import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { AuthService } from '../../services/auth.service';

@Component({
    selector: 'app-signin',
    templateUrl: './signin.component.html',
    styleUrls: ['./signin.component.css']
})
export class SigninComponent implements OnInit {

    created: boolean = false;
    password: string;
    email: string;
    errMsg: string;

    constructor(private router: Router,
        private authService: AuthService) { }

    ngOnInit() {
    }

    signin() {
	this.authService.signin(this.password, this.email).subscribe(
	    (res) => {
                if (res.success)
                    this.created = true;
                else
                    this.errMsg = res.err;
	    },
	    (error) => this.errMsg = error
        );
    }
}
